import { combineReducers } from "redux";
import flightBookAppReducer from "./filghtBookApp/fightBookAppReducer";

const rootReducer = combineReducers({
  flightApp: flightBookAppReducer,
});

export default rootReducer;
